  document.addEventListener('DOMContentLoaded', function() {
  const contactForm = document.getElementById('contactForm');
  const workerUrl = window.CONTACT_WORKER_URL;

    const callBackSelect = document.getElementById('callBack');
  const phoneInput = document.getElementById('phone');
  
  if (callBackSelect && phoneInput) {
    function togglePhoneRequirement() {
      if (callBackSelect.value === 'yes') {
        phoneInput.setAttribute('required', 'required');
      } else {
        phoneInput.removeAttribute('required');
      }
    }

  // Set initial state on page load
  togglePhoneRequirement();

  // Update requirement whenever the dropdown changes
  callBackSelect.addEventListener('change', togglePhoneRequirement);
  }

  // Display elements after picking an enquiry type
  const dropdown = document.getElementById('subject'); // Fix the ID

  const productModels = document.getElementById('productmodels');
  const serialNumber = document.getElementById('serialNumber');
  const dataRemoval = document.getElementById('data_removal_message');

  dropdown.addEventListener('change', function () {
    const selected = dropdown.value;

    // Always hide all
    productModels.style.display = 'none';
    serialNumber.style.display = 'none';
    dataRemoval.style.display = 'none';

    // Show relevant elements
    const showProductAndSerial = [
      "Repairs Page: In-Warranty",
      "Repairs Page: Out-Of-Warranty",
      "Repairs Page: Not Sure If In Warranty",
    ];

    if (showProductAndSerial.includes(selected)) {
      productModels.style.display = 'block';
      serialNumber.style.display = 'block';
    }

    if (selected === "Remove_My_Data") {
      dataRemoval.style.display = 'block';
    }
  });
  // Display elements after picking an enquiry type - ends
  
  if (contactForm) {
    // Helper function to get form values by data-name attribute
    function getFormValueByName(formData, name) {
      const field = contactForm.querySelector(`[data-name="${name}"]`);
      if (!field) return null;
      
      // Check if it's a checkbox
      if (field.type === 'checkbox') {
        return field.checked ? 'yes' : 'no';
      }
      
      // For everything else, get the value from formData using the Salesforce field ID
      return formData.get(field.name);
    }
    
    // Get field ID by data-name attribute
    function getFieldIdByName(name) {
      const field = contactForm.querySelector(`[data-name="${name}"]`);
      return field ? field.name : null;
    }
    
    // Salesforce field mapping function - updated to work with Salesforce IDs
    function mapToSalesforceFields(formData, finalMessage) {
      // Get Salesforce field IDs for key fields
      const emailFieldId = getFieldIdByName('email');
      const firstNameFieldId = getFieldIdByName('firstName');
      const lastNameFieldId = getFieldIdByName('lastName');
      const phoneFieldId = getFieldIdByName('phone');

      const address1FieldId = getFieldIdByName('address1');
      const address2FieldId = getFieldIdByName('address2');
      const townFieldId = getFieldIdByName('town');
      const stateFieldId = getFieldIdByName('state');
      const postcodeFieldId = getFieldIdByName('postcode');

      const countryFieldId = getFieldIdByName('country');
      const formTypeFieldId = getFieldIdByName('formType');
      const enquiryTypeFieldId = getFieldIdByName('enquiryType');
      const productmodelsFieldId = getFieldIdByName('productmodels');
      const serialNumberFieldId = getFieldIdByName('serialNumber');
      const newsletterFieldId = getFieldIdByName('newsletter');
      const privacyConsentFieldId = getFieldIdByName('privacyConsent');

      return {
        // Contact information - use the Salesforce IDs directly
        'sf_email': formData.get(emailFieldId),
        'sf_firstName': formData.get(firstNameFieldId),
        'sf_lastName': formData.get(lastNameFieldId),
        'sf_phone': formData.get(phoneFieldId),
        'sf_country': formData.get(countryFieldId),

        // Address
        'sf_address1': formData.get(address1FieldId),
        'sf_address2': formData.get(address2FieldId),
        'sf_town': formData.get(townFieldId),
        'sf_state': formData.get(stateFieldId),
        'sf_postcode': formData.get(postcodeFieldId),
        
        // Enquiry details
        'sf_formType': document.querySelector('[data-id="formType"]').value,
        'sf_enquiryType': formData.get(enquiryTypeFieldId),
        'sf_productModel': formData.get(productmodelsFieldId),
        'sf_serialNumber': formData.get(serialNumberFieldId),
        'sf_message': finalMessage,
        
        // Marketing preferences
        'newsletter': formData.get(newsletterFieldId),
        'sf_privacyConsent': document.querySelector(`[data-id="privacyConsent"]`).checked ? 'yes' : 'no',
        
        // Submission metadata
        'sf_submissionDate': new Date().toISOString(),
        'sf_submissionURL': window.location.href
      };
    }
    
    contactForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      // Get form values
      // Modify phone before collecting form data
      const dialCode = document.getElementById('dialCode')?.value || '';
      const phoneInput = document.getElementById('phone');
      const fullPhone = dialCode + (phoneInput?.value.trim().replace(/^0+/, '') || '');
      if (phoneInput) phoneInput.value = fullPhone;
      
      // Now collect form data
      const formData = new FormData(contactForm);

      // Build the final message once
      const messageFieldId = getFieldIdByName('message');
      let finalMessage = formData.get(messageFieldId) || '';
      const callbackSelect = document.getElementById('callBack');
      if (callbackSelect && callbackSelect.value === 'yes') {
        finalMessage = "!!! Customer selected YES they would like a call back !!!\n" + finalMessage;
      }
      
      const klaviyoListId = document.querySelector('[data-id="klaviyoListId"]').value;
      
      // Check if the user wants to subscribe to the newsletter
      const wantsNewsletter = getFormValueByName(formData, 'newsletter') === 'yes';
      
      // Show loading state
      const submitButton = contactForm.querySelector('button[type="submit"]');
      const originalButtonText = submitButton.textContent;
      submitButton.disabled = true;
      // submitButton.textContent = 'Submitting...';
      
      try {
        // Generate Salesforce data mapping
        const salesforceData = mapToSalesforceFields(formData, finalMessage);
        console.log('Salesforce data:', salesforceData);
        
        // Map form fields to the structure expected by your worker
        const payload = {
          // Common fields
          formType: document.querySelector('[data-id="formType"]').value,
          firstName: getFormValueByName(formData, 'firstName'),
          lastName: getFormValueByName(formData, 'lastName'),
          email: getFormValueByName(formData, 'email'),

          address1: getFormValueByName(formData, 'address1'),
          address2: getFormValueByName(formData, 'address2'),
          town: getFormValueByName(formData, 'town'),
          state: getFormValueByName(formData, 'state'),
          postcode: getFormValueByName(formData, 'postcode'),

          newsletter: getFormValueByName(formData, 'newsletter'),
          region: getFormValueByName(formData, 'region'),
          productmodels: getFormValueByName(formData, 'productmodels'),
          serialNumber: getFormValueByName(formData, 'serialNumber'),

          // Klaviyo settings
          klaviyo: {
            listId: klaviyoListId,
            addToList: wantsNewsletter
          },
          
          // Salesforce data
          salesforce: salesforceData,
          
          // All other form fields
          phone: fullPhone,
          country: getFormValueByName(formData, 'country'),
          enquiryType: getFormValueByName(formData, 'enquiryType'),
          message: finalMessage,
          website_url: window.location.href
        };

        // ✅ Execute reCAPTCHA and inject token into payload
        grecaptcha.ready(function () {
        grecaptcha.execute('6Lfh3kIrAAAAAGD4NBTJ6C8m73MZ5TWIwh-t95CU', { action: 'submit' }).then(async function (token) {
          try {
            payload.recaptchaToken = token;
      
            const response = await fetch(window.CONTACT_WORKER_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload)
            });
      
            const result = await response.json();
      
            // Logging and success handling...
            if (result.error) throw new Error(result.error);
      
            if (result.db && result.db.success) {
              document.getElementById('formSuccess').style.display = 'block';
            } else if (result.klaviyo && result.klaviyo.success) {
              document.getElementById('formSuccess').style.display = 'block';
            } else {
              throw new Error('Form submission failed');
            }
      
            contactForm.reset();
          } catch (error) {
            console.error('Detailed error:', error);
            document.getElementById('formError').style.display = 'block';
          } finally {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          }
        });
      }); // closes grecaptcha.ready
    } catch (error) {
      console.error('Detailed error:', error);
      document.getElementById('formError').style.display = 'block';
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
    }
  }); // closes form submit handler

     // 7. Popup Modal Logic
  const popupContainer = document.getElementById('customPopupContainer');
  const popupTriggers = document.querySelectorAll('.popup-trigger');
  const overlay = document.getElementById('customPopupOverlay');
  const closeButton = document.querySelector('.custom-popup-close');
  
  function showPopup(contentHTML) { 
    popupContainer.innerHTML = contentHTML; // Inject custom content
    overlay.style.display = 'flex'; // Show overlay
    document.body.style.overflow = 'hidden'; // Disable scrolling
  }
  function closePopup() { 
    overlay.style.display = 'none'; // Hide overlay
    popupContainer.innerHTML = ''; // Clear popup content
    document.body.style.overflow = 'auto'; // Re-enable scrolling  
  }
  
  popupTriggers.forEach(trigger => { 
    trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const contentId = this.getAttribute('data-popup-content'); // Get the ID of the content to show
        const contentHTML = document.getElementById(contentId).innerHTML; // Fetch the HTML
        showPopup(contentHTML); // Show the popup with fetched content
    });
  });
  closeButton.addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
          closePopup();
      }
  });
  document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
          closePopup();
      }
  });
    
}
}); // closes DOMContentLoaded